import React from 'react';
import '../../App.css';
import './user-control.css';
import CSS from 'csstype';

// functions
import { apiPrefix } from '../../utils/functions';

// images
import { Copy } from 'lucide-react';

// classes
import Scrollbox from '../../tools/scrollbox';
import MiniButton from '../../tools/mini-button';

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

interface UserControlOIDCTokenProps {} // UserControlOIDCTokenProps

interface UserControlOIDCTokenState {
  authToken: string;
  gatewayBackendToken: string;
  siteCapabilitiesToken: string;
  dataManagementToken: string;
} // UserControlOIDCTokenState

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default class UserControlOIDCToken extends React.Component<
  UserControlOIDCTokenProps,
  UserControlOIDCTokenState
> {
  constructor(props: UserControlOIDCTokenProps) {
    super(props);
    this.state = {
      authToken: '',
      gatewayBackendToken: '',
      siteCapabilitiesToken: '',
      dataManagementToken: '',
    };
  }

  //	------------------------------------------------------------
  //
  //	Get the oidc tokens from the backend
  //
  //	------------------------------------------------------------

  async componentDidMount() {
    console.log('/get_tokens being called');
    try {
      // call the /get_tokens endpoint here.
      const apiResult = await fetch(apiPrefix() + '/v1/get_tokens', {
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      if (apiResult.status === 200) {
        const returnedJson = await apiResult.json();
        console.log('/get_tokens');
        console.log(returnedJson);

        // update state.
        if (
          returnedJson.auth_token !== undefined &&
          typeof returnedJson.auth_token === 'string'
        )
          this.setState({
            authToken: returnedJson.auth_token,
          });
        if (
          returnedJson.gateway_backend_token !== undefined &&
          typeof returnedJson.gateway_backend_token === 'string'
        )
          this.setState({
            gatewayBackendToken: returnedJson.gateway_backend_token,
          });
        if (
          returnedJson.site_capabilities_token !== undefined &&
          typeof returnedJson.site_capabilities_token === 'string'
        )
          this.setState({
            siteCapabilitiesToken: returnedJson.site_capabilities_token,
          });
        if (
          returnedJson.data_management_token !== undefined &&
          typeof returnedJson.data_management_token === 'string'
        )
          this.setState({
            dataManagementToken: returnedJson.data_management_token,
          });
      }
    } catch (e) {
      console.log(e);
    }
  } // componentDidMount

  //	------------------------------------------------------------
  //
  //	Component code
  //
  //	------------------------------------------------------------

  render() {
    return (
      <div
        className="text-colour"
        style={{
          flex: '1 1',
          width: '100%',
          height: '100%',
          padding: '0px 10px 0px 0px',
        }}
      >
        <div
          role="region"
          aria-labelledby="oidc-tokens-label"
          className="panel-main"
          style={{
            flexDirection: 'column',
          }}
        >
          <label
            id="oidc-tokens-label"
            className="form-title"
            role="heading"
            aria-level={1}
            style={{
              margin: '10px 0px 10px 5px',
            }}
          >
            OIDC tokens
          </label>
          <Scrollbox
            direction="vertical"
            width="100%"
            flex="1 1"
            flexDirection="column"
            padding="0px 5px 0px 5px"
          >
            <table className="user-oidc">
              <tbody>
                <tr className="user-oidc-row">
                  <td className="user-oidc-text">Auth access token:</td>
                  <td className="user-oidc-text">
                    <MiniButton
                      className="text-colour"
                      onClick={() => {
                        navigator.clipboard.writeText(this.state.authToken);
                      }}
                    >
                      <Copy width={30} height={30} strokeWidth={1.5} />
                    </MiniButton>
                  </td>
                  <td className="user-oidc-cell">
                    {this.state.authToken.substring(0, 50) +
                      '.....' +
                      this.state.authToken.substring(this.state.authToken.length - 50)}
                  </td>
                </tr>
                <tr className="user-oidc-row" />
                <tr className="user-oidc-row">
                  <td className="user-oidc-text">Site capabilities access token:</td>
                  <td className="user-oidc-text">
                    <MiniButton
                      className="text-colour"
                      onClick={() => {
                        navigator.clipboard.writeText(this.state.siteCapabilitiesToken);
                      }}
                    >
                      <Copy width={30} height={30} strokeWidth={1.5} />
                    </MiniButton>
                  </td>
                  <td className="user-oidc-cell">
                    {this.state.siteCapabilitiesToken.substring(0, 50) +
                      '.....' +
                      this.state.siteCapabilitiesToken.substring(
                        this.state.siteCapabilitiesToken.length - 50,
                      )}
                  </td>
                </tr>
                <tr className="user-oidc-row" />
                <tr className="user-oidc-row">
                  <td className="user-oidc-text">Data management access token:</td>
                  <td className="user-oidc-text">
                    <MiniButton
                      className="text-colour"
                      onClick={() => {
                        navigator.clipboard.writeText(this.state.dataManagementToken);
                      }}
                    >
                      <Copy width={30} height={30} strokeWidth={1.5} />
                    </MiniButton>
                  </td>
                  <td className="user-oidc-cell">
                    {this.state.dataManagementToken.substring(0, 50) +
                      '.....' +
                      this.state.dataManagementToken.substring(
                        this.state.dataManagementToken.length - 50,
                      )}
                  </td>
                </tr>
                <tr className="user-oidc-row" />
                <tr className="user-oidc-row">
                  <td className="user-oidc-text">Gateway-backend access token:</td>
                  <td className="user-oidc-text">
                    <MiniButton
                      className="text-colour"
                      onClick={() => {
                        navigator.clipboard.writeText(this.state.gatewayBackendToken);
                      }}
                    >
                      <Copy width={30} height={30} strokeWidth={1.5} />
                    </MiniButton>
                  </td>
                  <td className="user-oidc-cell">
                    {this.state.gatewayBackendToken.substring(0, 50) +
                      '.....' +
                      this.state.gatewayBackendToken.substring(
                        this.state.gatewayBackendToken.length - 50,
                      )}
                  </td>
                </tr>
              </tbody>
            </table>
          </Scrollbox>
        </div>
      </div>
    );
  }
} // UserControlOIDCToken
